import * as _ from 'underscore';

import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { Set } from './Set';

export interface IErrorItem<T> {
  item: T;
  error: IError;
}

export class MultipleItemResult<T> {

  public successCount: number;
  public errorCount: number;

  constructor(private items: Set<T>,
              private serverResult: IResult) {
    if (serverResult) {
      this.errorCount = serverResult.errors ? serverResult.errors.length : 0;
    } else {
      this.errorCount = 0;
    }
    this.successCount = items.size() - this.errorCount;
  }

  public anySucceeded(): boolean {
    return this.successCount > 0;
  }

  public anyFailed(): boolean {
    return this.errorCount > 0;
  }

  public errorItems(): IErrorItem<T>[] {
    return _.map(this.serverResult.errors, (error: IError) => {
      return {
        error: error,
        item: this.items.get(error.id)
      };
    });
  }

  public firstSuccessfulItem(): T {
    if (this.successCount === 0) {
      return null;
    }
    return _.once(() => {
      const errorIds = this.errorCount ?  _.map(this.serverResult.errors, (error: IError) => error.id) : [];
      const successIds = _.difference(this.items.keys(), errorIds);
      return this.items.get(successIds[0]);
    })();
  }

}
